<script lang='ts'>
import { useNavigate } from "svelte-navigator";
import { login } from "../services";
import { loginUser } from "../store";
import CircularProgress from './CircularProgress.svelte';
import * as config from '../config.json';

interface LoginResponse {
  id: string;
  token: string;
}

export let title;
export let subtitle;

const navigate = useNavigate();

let first = '';
let last = '';
let org = '';
let email = '';
let orgTitle = '';

let loading = false;
let error;
let errorRef;

async function submit() {
  error = undefined
  
  if (!first.trim()) {
    error = "Please enter your first name";
  } else if (!last.trim()) {
    error = "Please enter your last name";
  } else if (!email.trim() || email.indexOf('@') === -1) {
    error = "Please enter your email";
  } else if (!org.trim()) {
    error = 'Please provide your organization';
  } else if (!orgTitle.trim()) {
    error = 'Please provide your organization title';
  }

  if (error) {
    window.scrollTo({top: errorRef.offsetTop, behavior: 'smooth'});
    return;
  }

  loading = true;

  try {
    const {id, token}: LoginResponse = await login({email, first, last, org, orgTitle, eventId: config.eventId, companyId: config.companyId});
    loginUser(id, token, email, first, last)
    navigate('/', { replace: true });
  } catch (e) {
    error = e.message;
  } finally {
    loading = false;
  }
}
</script>

<div class="login-title">
  {@html title}
</div>

<div class="login-subtitle">
  {@html subtitle}
</div>

<form on:submit|preventDefault={submit} bind:this={errorRef}>
  {#if error}
    <div class="error-box mb-4">
      {error}
    </div>
  {/if}

  <div class="rowtocol mb-4">
    <div class="col flex-1">
      <div class="form-label">First Name *</div>
      <input bind:value={first} type="text" name="first" placeholder="First Name" />
    </div>
    <div class="gutter" />
    <div class="col flex-1">
      <div class="form-label">Last Name *</div>
      <input bind:value={last} type="text" name="last" placeholder="Last Name" />
    </div>
  </div>
  
  <div class="col mb-4">
    <div class="form-label">Email *</div>
    <input bind:value={email} type="email" name="email" placeholder="Email" />
  </div>

  <div class="rowtocol mb-4">
    <div class="col flex-1">
      <div class="form-label">Organization *</div>
      <input bind:value={org} type="text" name="organization" placeholder="Organization" />
    </div>
    <div class="gutter" />
    <div class="col flex-1">
      <div class="form-label">Title *</div>
      <input bind:value={orgTitle} type="text" name="orgtitle" placeholder="Title" />
    </div>
  </div>

  <div class="row vcenter between" style="margin-top: 16px">
    <div>* Required</div>
    {#if loading}
      <CircularProgress />
    {:else}
      <button type="submit" class="button">SIGN IN</button>
    {/if}
  </div>
</form>

<style lang="scss">
@import '../util';

.box {
  background: white;
  max-width: 784px;
  width: 784px;

  @include landscape {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .content {
    padding: 32px;
  
    @include landscape {
      padding: 16px;
    }
  }
}

.topbar {
  background-color: var(--primary);
  border: 5px solid white;
  color: var(--text-primary);
  font-weight: 350;
  letter-spacing: 0.2em;
  height: 68px;
}
</style>